import React from "react";
import PropTypes from "prop-types";

const Button = ({ className, disabled, type, buttonProps ,onClick, children }) => {
  return (
    <button
      type={type}
      className={`btn border rounded shadow-sm ${className}`}
      disabled={disabled}
      onClick={onClick}      
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  buttonProps: PropTypes.object,
  children: PropTypes.node
};

export default Button;
